(() => {
  const selector = '.globo-form-id-162624 .globo-form-app input[data-type="email"]';
  const white = '#f8f9fa';
  let focusedTimer;

  function setWhite(input, property) {
    if (input.style.getPropertyValue(property) === white &&
        input.style.getPropertyPriority(property) === 'important') return;
    input.style.setProperty(property, white, 'important');
  }

  function paint(input) {
    if (!(input instanceof HTMLInputElement) || !input.matches(selector)) return;
    setWhite(input, 'color');
    setWhite(input, '-webkit-text-fill-color');
    setWhite(input, 'caret-color');
  }

  function paintCurrent() {
    document.querySelectorAll(selector).forEach(paint);
  }

  // Some mobile autofill suggestions replace the value after the input event.
  function paintAfterInput(input) {
    if (!(input instanceof HTMLInputElement) || !input.matches(selector)) return;
    paint(input);
    requestAnimationFrame(() => paint(input));
    setTimeout(() => paint(input), 150);
  }

  for (const event of ['input', 'change', 'keyup', 'animationstart']) {
    document.addEventListener(event, ({ target }) => paintAfterInput(target), true);
  }
  document.addEventListener('focusin', ({ target }) => {
    if (!target.matches(selector)) return;
    paintAfterInput(target);
    clearInterval(focusedTimer);
    focusedTimer = setInterval(() => paint(target), 250);
  }, true);
  document.addEventListener('focusout', ({ target }) => {
    if (!target.matches(selector)) return;
    clearInterval(focusedTimer);
    paintAfterInput(target);
  }, true);
  window.addEventListener('pageshow', paintCurrent);
  new MutationObserver(paintCurrent).observe(document.documentElement, { childList: true, subtree: true });
  paintCurrent();
})();
